import { render, staticRenderFns } from "./allprjPrivi.vue?vue&type=template&id=7aa89bc6&scoped=true"
import script from "./allprjPrivi.vue?vue&type=script&lang=js"
export * from "./allprjPrivi.vue?vue&type=script&lang=js"
import style0 from "./allprjPrivi.vue?vue&type=style&index=0&id=7aa89bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa89bc6",
  null
  
)

export default component.exports